// Department-specific validation - Uses generic validation utility
import { createValidation } from '../../utils/validation';

/**
 * Department-specific validation factory
 * This is a thin wrapper around the generic validation utility
 * for backwards compatibility with existing department module code
 */
export const createDepartmentValidation = (fields) => {
  const validation = createValidation(fields);
  
  // Return the same interface but with department-specific method names
  return {
    schema: validation.schema,
    validateDepartmentData: validation.validateData,
    validateField: validation.validateField
  };
};

// Default export for backwards compatibility
export default createDepartmentValidation;
